import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { theme, responsiveFontSizes, responsiveSpacing } from '../theme/theme';

const GradientContainer = styled(Box)(() => ({
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: `linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.accent} 50%, ${theme.colors.primary} 100%)`,
  position: 'relative',
  overflow: 'auto',
}));

const SplashScreen = () => {
  return (
    <GradientContainer>
      <Box sx={{ textAlign: 'center', px: { xs: responsiveSpacing.xs, sm: responsiveSpacing.component } }}>
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5 }}
        >
          <Typography sx={{ fontSize: { xs: '60px', sm: '80px', md: '100px' }, mb: responsiveSpacing.xs }}>✨</Typography>
          <Typography
            variant="h2"
            sx={{
              fontWeight: 'bold',
              color: '#FFFFFF',
              mb: responsiveSpacing.xs,
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
              fontSize: { xs: responsiveFontSizes.h3, sm: responsiveFontSizes.h2, md: responsiveFontSizes.h1 },
            }}
          >
            紫微AI
          </Typography>
          <Typography
            variant="h5"
            sx={{
              color: '#F5F5DC',
              fontWeight: 300,
              letterSpacing: { xs: 1, sm: 2 },
              mb: { xs: responsiveSpacing.component, sm: responsiveSpacing.section },
              fontSize: { xs: responsiveFontSizes.h6, sm: responsiveFontSizes.h5 },
            }}
          >
            紫微斗数
          </Typography>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.5, delay: 0.5 }}
        >
          <Typography
            sx={{
              fontSize: { xs: responsiveFontSizes.body1, sm: responsiveFontSizes.h6 },
              color: '#F5F5DC',
              lineHeight: 1.5,
              mb: responsiveSpacing.xs,
            }}
          >
            以中国古老智慧探索您的命运旅程
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: responsiveFontSizes.h6, sm: responsiveFontSizes.h5 },
              color: '#FFD700',
              fontWeight: 'bold',
            }}
          >
            紫微斗数 (Zi Wei Dou Shu)
          </Typography>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2, delay: 1, repeat: Infinity, repeatType: 'reverse' }}
        >
          <Typography
            sx={{
              fontSize: { xs: responsiveFontSizes.body1, sm: responsiveFontSizes.h6 },
              color: '#FFFFFF',
              fontWeight: 300,
              mt: { xs: responsiveSpacing.section, sm: Number(responsiveSpacing.section) * 1.5 },
            }}
          >
            正在为您载入宇宙旅程……
          </Typography>
        </motion.div>
      </Box>

      {/* Decorative Elements */}
      <Box sx={{ position: 'absolute', top: '10%', left: { xs: '5%', sm: '10%' }, fontSize: { xs: '30px', sm: '40px' }, opacity: 0.3, color: '#FFD700' }}>☯</Box>
      <Box sx={{ position: 'absolute', top: '15%', right: { xs: '5%', sm: '10%' }, fontSize: { xs: '30px', sm: '40px' }, opacity: 0.3, color: '#FF6B6B' }}>🌙</Box>
      <Box sx={{ position: 'absolute', bottom: '15%', left: { xs: '8%', sm: '15%' }, fontSize: { xs: '30px', sm: '40px' }, opacity: 0.3, color: '#4ECDC4' }}>⭐</Box>
      <Box sx={{ position: 'absolute', bottom: '10%', right: { xs: '8%', sm: '15%' }, fontSize: { xs: '30px', sm: '40px' }, opacity: 0.3, color: '#45B7D1' }}>🔮</Box>
    </GradientContainer>
  );
};



export default SplashScreen;